import { indexDB } from 'ynf-core-middleware'
import request from 'ynf-core-engine/request'
import { getMultiLocale } from '../util'

// 多语注入
const getMultiDbInstance = async () => {
  const dbInstance = await indexDB.init("ynfMultiDB", 1, [
    { tableName: "ynfMultiCache", options: { keyPath: "ynfMultiId", autoIncrement: false } },
  ]);
  return dbInstance;
}

const getMultiData = async (dbInstance, key) => {
  const res = await dbInstance.query("ynfMultiCache", (item) => item.ynfMultiId === key)
  return res[0] || null
}

const insertMultiData = async (dbInstance, data) => {
  await dbInstance.insert("ynfMultiCache", data);
}

const updateMultiData = async (dbInstance, data) => {
  await dbInstance.update("ynfMultiCache", (item) => item.ynfMultiId === data.ynfMultiId, (item) => {
    item.dataTime = data.dataTime
    item.data = data.data
    return item
  })
}

const getMultiDbKey = (tplId) => {
  const locale = getMultiLocale()
  return `${tplId}_${locale}`
}

const isTimeout = (time) => {
  const currentTime = new Date().getTime()
  let timeLimit = 24 * 60 * 60
  // 测试和日常环境限制在1000ms，其他环境是一天
  if (window.__SERVER_ENV__ === 'test' || window.__SERVER_ENV__ === 'daily') {
    timeLimit = 1000
  }
  return currentTime - time > timeLimit;
}

export const getMultiRes = async (url, billNo, tplId, params) => {
  const dbInstance = await getMultiDbInstance()
  const key = getMultiDbKey(tplId)
  const data = await getMultiData(dbInstance, key)
  // 命中缓存，且在有效时间（3天）内，3 * 24 * 60 * 60
  if (data && !isTimeout(data.dataTime)) {
    return data
  } else {
    // 请求
    const res = await request({
      url: `/mdf-node/qtmProxy${url}?billNo=${billNo}&tplId=${tplId}&domainKey=${params.domainKey}&serviceCode=${params.serviceCode || ''}`,
      method: 'get',
      params
    })
    // 如果后端没返回多语数据，则不进行缓存
    if (!res.data || Object.keys(res.data).length === 0) return { data: {} }
    // 包装newData
    const newData = {
      ynfMultiId: key,
      dataTime: new Date().getTime(),
      data: res.data
    }
    data ? await updateMultiData(dbInstance, newData) : await insertMultiData(dbInstance, newData)
    return res
  }
}